import React from "react";
import { PaginatedEntityTable } from "components/common";
import { fetchPaginatedSharedCollections, keyFn } from "collections/hooks/useSharedCollections";
import customColumnRenderers from "./customColumnRenderers";
const DEFAULT_DISPLAYED_ATTRIBUTES = ["title", "description", "manage", "content"];
export const DEFAULT_LAYOUT = {
  entityTableId: "shared_collections",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: DEFAULT_DISPLAYED_ATTRIBUTES,
  defaultColumnOrder: DEFAULT_DISPLAYED_ATTRIBUTES
};
const CollectionsList = ({ filterBy, id }) => /* @__PURE__ */ React.createElement(
  PaginatedEntityTable,
  {
    humanName: "collections",
    tableLayout: DEFAULT_LAYOUT,
    fetchEntities: (searchParams) => fetchPaginatedSharedCollections(searchParams, filterBy, id),
    keyFn: (searchParams) => keyFn(searchParams, filterBy, id),
    columnRenderers: customColumnRenderers,
    entityAttributesAreCamelCase: false,
    searchPlaceholder: "Search for collection"
  }
);
export default CollectionsList;
